export default __webpack_public_path__ + "static/Case-Study-Tillys-3d1b5d1275074cdc45042cce0c8462a1.pdf";